import { render, staticRenderFns } from "./EditorInsertEmailButton.vue?vue&type=template&id=56893dae"
import script from "./EditorInsertEmailButton.vue?vue&type=script&lang=js"
export * from "./EditorInsertEmailButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports